import { IMenuItem } from '../../Common';

interface IRadioGroup {
    value: string;
    options: IMenuItem[];
    onChange: (value: string | number) => void;
}

export const RadioGroup = ({ value, options, onChange }: IRadioGroup) => {
    return (
        <>
            {options.map((option: IMenuItem) => (
                <div key={option.label}>
                    <input
                        className="radio-group__input"
                        id={option.value.toString()}
                        type="radio"
                        name="type"
                        value={value}
                        checked={value === option.value}
                        onChange={() => onChange(option.value)}
                    />
                    <label htmlFor={option.value.toString()} className="radio-group__label" key={option.value}>
                        {option.label}
                    </label>
                </div>
            ))}
        </>
    );
};
